export default __webpack_public_path__ + "70b6fc264307ba31574816e8612408ca.png";